export default __webpack_public_path__ + "static/media/burger.ef805f93.svg";